import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';

@Component({
  selector: 'app-route-fee-structure',
  templateUrl: './route-fee-structure.component.html',
  styleUrls: ['./route-fee-structure.component.css']
})
export class RouteFeeStructureComponent implements OnInit {

  constructor(private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  RouteLocationMapModel = {
    RouteID: 0,
    LocationID: 0,
    RouteLocationID: 0,
    LocationName: '',
    RouteName: '',
    XmlData: '',
    IsActive: false
 }
 tab = 1;

setTab  (tabId) {
 
    this.tab = tabId;
};

//this.isSet  (tabId) {
//    return this.tab === tabId;
//};
RouteFeeStructureModel = {
    RouteID: 0,
    LocationID: 0,
    LocationName: '',      
    XmlData: '',
    IsActive: false
  
}

 ValidateDropdown() {
    return this.RouteLocationMapModel.RouteID == 0
};

Submitted = false;
LocationRootMapList:any;
SaveRouteLocationMap  (valid) {
   
    this.Submitted = true;
    if (valid && !this.ValidateDropdown()) {
        this.spinnerService.show();       
           this.transportService.SaveRouteLocationMap(JSON.stringify(this.RouteLocationMapModel), JSON.stringify(this.LocationRootMapList)).subscribe( (response)=> {
            this.spinnerService.hide(); 
            this.globalHelper.CheckActionStatus(response);
        });
    }
};

 ValidateDropdownn() {
    return  this.RouteFeeStructureModel.RouteID == 0
};

Submitted1 = false;
LocationList:any;
SaveRouteFeeStructure  () {
   
    this.Submitted1 = true;
    if (!this.ValidateDropdownn()) {
        var RouteselectedList = [];
        var strRoute = this.LocationList;
        for (var i = 0; i < strRoute.length; i++) {
            RouteselectedList.push(strRoute[i]);
        }
        
        this.spinnerService.show();
        this.transportService.SaveRouteFeeStructure(JSON.stringify(RouteselectedList), this.RouteFeeStructureModel.RouteID).subscribe( (response)=> {
          this.spinnerService.hide();
           this.globalHelper. CheckActionStatus(response);
        });
    }
};


// Get All Value Using RouteID
RouteFeeStructureList = [];
GetAllRouteFeeStructure  () {
  this.spinnerService.show();
    this.transportService.GetAllRouteFeeStructure(this.RouteLocationMapModel.RouteID).subscribe( (data)=> {                            
        this.LocationRootMapList = data.RouteFeeStructureList;
        this.spinnerService.hide();
    });
};


RouteFeeStructureListMap = [];
InstallmentList:any;
GetAllRouteFeeStructureList  () {
  this.spinnerService.show();
    this.transportService.GetAllRouteFeeStructureList(this.RouteFeeStructureModel.RouteID).subscribe( (data)=> {
        this.LocationList = data.RouteFeeStructureListMap;
        this.InstallmentList = data.InstallmentList;
        this.spinnerService.hide();
                  
    });
};


Clear  () {
    this.RouteLocationMapModel.RouteID = 0;
};


Route:any;
GetAllRoute  () {
    this.lookupService.GetLookupsList('RouteName', '').subscribe( (data)=> {
        this.Route = data.LookupItems;
    });

};
Routes:any;
GetAllRoutes  () {
    this.lookupService.GetLookupsList('RouteName', '').subscribe( (data)=> {
        this.Routes = data.LookupItems;
    });

};
  ngOnInit() {
    this.GetAllRoute();
    this.GetAllRoutes();  
  }

}
